import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface CreateSessionResponse {
  studioId: string;
  name: string;
  startDate: string;
  endDate: string;
  isRegistrationFee: boolean;
  registrationFeeAmount: number;
  isArchive: boolean;
  isDefault: boolean;
  isClassDefault: boolean;
  isEventDefault: boolean;
  billingDate: string | null;
  chargeSessionFeesAtEnrollment?: boolean;
  _id: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface CreateSessionParams {
  name: string;
  startDate: string;
  endDate: string;
  isRegistrationFee: boolean;
  registrationFeeAmount?: number;
  isClassDefault: boolean;
  isEventDefault: boolean;
  billingDate?: string;
  registrationFeePerStudent?: Record<number, number>;
  visibleInParentPortal?: boolean;
  chargeLastMonthAtCheckout?: boolean;
  chargeFirstMonthHourlyAtCheckout?: boolean;
  chargeSessionFeesAtEnrollment?: boolean;
}

export const createSessionAPI = async (sessionDetails: CreateSessionParams) => {
  const resp = await baseAPI.post<CreateSessionResponse>(
    '/session',
    sessionDetails,
  );
  return resp.data;
};

export const useCreateSessionMutation = () => {
  return useMutation({
    mutationFn: async (sessionDetails: CreateSessionParams) => {
      const response = await createSessionAPI(sessionDetails);
      return response;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.SESSIONS],
      });
      // The All Classes filter dropdown derives its session options from
      // the classes search response (data.sessions), not from /session/search.
      // Invalidate KEYS.CLASSES so the dropdown picks up the new session
      // immediately, without waiting for React Query's staleTime to lapse.
      void queryClient.invalidateQueries({
        queryKey: [KEYS.CLASSES],
      });
    },
  });
};
